import { render, staticRenderFns } from "./wfo_seating-a45.vue?vue&type=template&id=03c2312c&"
import script from "./wfo_seating-a45.vue?vue&type=script&lang=js&"
export * from "./wfo_seating-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports